import shared from './main.module.scss';

window.shared = shared;
